import { useState } from "react";
import { Link } from "react-router-dom";
import { FiMail, FiArrowLeft, FiCheckCircle } from "react-icons/fi";
import api from "../services/api";
import "../styles/account.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await api.auth.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="kkb-page">
        <div className="kkb-auth">
          <div className="kkb-auth__container kkb-auth__container--small">
            <div className="kkb-auth__box" style={{ textAlign: "center" }}>
              <FiCheckCircle size={60} color="#8B6914" />
              <h2 style={{ marginTop: "20px", color: "#8B6914" }}>
                Check Your Email
              </h2>
              <p style={{ marginTop: "10px", color: "#666" }}>
                We've sent a password reset link to <strong>{email}</strong>
              </p>
              <p style={{ marginTop: "5px", fontSize: "14px", color: "#999" }}>
                The link will expire in 1 hour.
              </p>
              <Link
                to="/login"
                className="kkb-btn kkb-btn--primary"
                style={{ marginTop: "30px" }}
              >
                <FiArrowLeft size={14} /> Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="kkb-page">
      <div className="kkb-auth">
        <div className="kkb-auth__container kkb-auth__container--small">
          <div className="kkb-auth__box">
            <div className="kkb-auth__logo">KKB & Co.</div>
            <h2 className="kkb-auth__title" style={{ textAlign: "center" }}>
              Forgot Password?
            </h2>
            <p
              className="kkb-auth__subtitle"
              style={{ textAlign: "center", marginBottom: "30px" }}
            >
              Enter your email address and we'll send you a link to reset your
              password.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="kkb-form__group">
                <label className="kkb-form__label">Email Address</label>
                <div className="kkb-form__input-wrap">
                  <FiMail
                    size={16}
                    style={{
                      position: "absolute",
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#999",
                    }}
                  />
                  <input
                    className="kkb-form__input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@email.com"
                    style={{ paddingLeft: "35px" }}
                    required
                  />
                </div>
              </div>

              {error && (
                <div
                  style={{
                    color: "#e74c3c",
                    fontSize: "14px",
                    marginTop: "-10px",
                    marginBottom: "15px",
                  }}
                >
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="kkb-btn kkb-btn--primary kkb-btn--full"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>

              <Link
                to="/login"
                className="kkb-auth__back-link"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  marginTop: "20px",
                  color: "#666",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                <FiArrowLeft size={14} /> Back to Login
              </Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
